// @flow
import { StructureItemActionTypes } from './constants';

const INIT_STATE = {
    item: {},
    listaItems: [],
    loading: false,
    error: false,
    formSubmited: false,
    filters: {}
};

type StructureItemAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { item?: {} | null, listaItems?: [] | null, loading?: boolean, +value ?: boolean };

const StructureItems = (state: State = INIT_STATE, action: StructureItemAction): any => {
    // console.log(action);
    switch (action.type) {
        case StructureItemActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case StructureItemActionTypes.GET_STRUCTURE_ITEM: {
                    return {
                        ...state,
                        item: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case StructureItemActionTypes.LIST_STRUCTURE_ITEMS: {
                    return {
                        ...state,
                        listaItems: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case StructureItemActionTypes.ADD_STRUCTURE_ITEM:
                case StructureItemActionTypes.UPDATE_STRUCTURE_ITEM: {
                    return {
                        ...state,
                        error: false,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case StructureItemActionTypes.DELETE_STRUCTURE_ITEM: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case StructureItemActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case StructureItemActionTypes.GET_STRUCTURE_ITEM: {
                    return {
                        ...state,
                        error: action.payload.error,
                        item: {},
                        loading: false,
                    };
                }
                case StructureItemActionTypes.LIST_STRUCTURE_ITEMS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaItems: [],
                        loading: false,
                    };
                }
                case StructureItemActionTypes.ADD_STRUCTURE_ITEM:
                case StructureItemActionTypes.UPDATE_STRUCTURE_ITEM: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case StructureItemActionTypes.DELETE_STRUCTURE_ITEM: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case StructureItemActionTypes.GET_STRUCTURE_ITEM:
            return { ...state, error: false, loading: true };
        case StructureItemActionTypes.LIST_STRUCTURE_ITEMS:
            return { ...state, error: false, loading: true };
        case StructureItemActionTypes.ADD_STRUCTURE_ITEM:
            return { ...state, error: false, loadingForm: true };
        case StructureItemActionTypes.UPDATE_STRUCTURE_ITEM:
            return { ...state, error: false, loadingForm: true };
        case StructureItemActionTypes.DELETE_STRUCTURE_ITEM:
            return { ...state, error: false, loading: true };
        case StructureItemActionTypes.RESET:
            return {
                ...state,
                loading: false,
                loadingForm: false,
                error: false,
                item: {},
                listaItems: [],
                formSubmited: false
            };
        case StructureItemActionTypes.SET_FILTER_STRUCTURE_ITEMS    :
            return {
                ...state,
                filters: action.payload
            }
        default:
            return { ...state };
    }
};

export default StructureItems;
